import { Component, Inject } from '@angular/core';
import { CoreFacade } from '@modules/core/core.facade';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'nx-ng-basket-error-modal',
  templateUrl: './basket-error-modal.component.html',
  styleUrls: ['./basket-error-modal.component.scss'],
})
export class BasketErrorModalComponent {
  canRetry = false;
  errorText = '';
  constructor(
    public dialogRef: MatDialogRef<BasketErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { canRetry: boolean; errorText: string },
    private coreFacade: CoreFacade
  ) {
    this.canRetry = data.canRetry;
    this.errorText = data.errorText;
  }

  get retryBtnText() {
    return this.canRetry ? 'try_again' : 'close';
  }

  handleTryAgain() {
    this.dialogRef.close();

    if (this.canRetry) {
      setTimeout(() => this.coreFacade.retryAllFailedActions(), 500);
    }
  }
}
